/**
 * Devises — le nombre de décimales est porté par la devise, jamais par la colonne.
 *
 * Un montant est TOUJOURS un entier exprimé dans la plus petite unité de la devise :
 *   1 234 XAF  → 1234   (0 décimale : le franc CFA n'a pas de subdivision en usage)
 *   12,34 EUR  → 1234   (2 décimales)
 *
 * C'est ce qui rend l'arithmétique exacte en JavaScript, où 0.1 + 0.2 !== 0.3.
 */
export const CURRENCIES = {
    XAF: { code: 'XAF', symbol: 'FCFA', decimals: 0, name: 'Franc CFA (BEAC)' },
    XOF: { code: 'XOF', symbol: 'FCFA', decimals: 0, name: 'Franc CFA (BCEAO)' },
    HTG: { code: 'HTG', symbol: 'G', decimals: 2, name: 'Gourde haïtienne' },
    USD: { code: 'USD', symbol: '$', decimals: 2, name: 'Dollar américain' },
    EUR: { code: 'EUR', symbol: '€', decimals: 2, name: 'Euro' },
    CAD: { code: 'CAD', symbol: '$', decimals: 2, name: 'Dollar canadien' },
    MAD: { code: 'MAD', symbol: 'DH', decimals: 2, name: 'Dirham marocain' },
};
export function isCurrencyCode(code) {
    return Object.prototype.hasOwnProperty.call(CURRENCIES, code);
}
export function getCurrency(code) {
    const currency = CURRENCIES[code];
    if (!currency) {
        throw new RangeError(`Devise inconnue : ${code}`);
    }
    return currency;
}
//# sourceMappingURL=currency.js.map